module.exports = __webpack_public_path__ + "img/process-2.7c470e30.png";